export default __webpack_public_path__ + "images/chart-line-blue.f953399e17168eb470c955471c314d27.png";